/* eslint-disable no-unsafe-optional-chaining */
import { useFetch } from '@/modules/orders/hooks/useFetch';
import { getFactureIdService, getOrdersByIdService, postFactureService } from '@/services';
import { axios, currentFormat, groupsOrdersDetailsWithProducts } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useCompanyCategory } from './useCompanyCategory';

export const useOrderId = (id: string) => {
  const queryClient = useQueryClient();
  const { isFoodCompany } = useCompanyCategory();

  const { data: dataOrder, fetchId } = useFetch({
    fetchFunction: getOrdersByIdService,
    getData: true,
  });
  const { data: dataInvoices, fetchId: factureId } = useFetch({
    fetchFunction: getFactureIdService,
    getData: true,
  });

  const { fetchId: fetchInvoice } = useFetch({
    fetchFunction: postFactureService,
  });

  const [invoicesResult, setInvoiceResult] = useState<any>();

  useEffect(() => {
    if (!dataInvoices) {

     const result = async () => {return setInvoiceResult(await fetchInvoice(id))}
     result()
    } else {
      return setInvoiceResult(dataInvoices);
    }
  }, [dataInvoices]);

  const reload = async () => {
    await factureId(id);
    await fetchId(id);
  };
  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const invoices = {
    id: invoicesResult?.id.slice(0, 7) ?? 0,
    base: currentFormat(invoicesResult?.base),
    taxes: currentFormat(invoicesResult?.taxes),
    total: isFoodCompany ? invoicesResult?.total + invoicesResult?.tips : invoicesResult?.total,
    discount: currentFormat(invoicesResult?.discount),
    tips: invoicesResult?.tips,
  };
  const billingInfo = {
    vendor: dataOrder?.vendor ?? {},
    table: dataOrder?.table ?? null,
    customer: dataOrder?.customer,
  };
  const generateBody = useCallback(() => {
    const newArrayOrders = dataOrder?.ordersDetails
      ? groupsOrdersDetailsWithProducts(dataOrder?.ordersDetails)
      : [];
    const newBody = newArrayOrders.map((item: any) => ({
      id: item.id.slice(0, 7),
      name: item.product.name,
      quantity: item.quantity,
      priceTotal: currentFormat(item.total),
    }));
    return newBody || [];
  }, [dataOrder]);

  const invalidateByCheckout = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['invoices', id ?? ''] });
    queryClient.invalidateQueries({ queryKey: ['orders', id ?? ''] });
  }, [id, queryClient]);

  const invoicesWhitOutFormat = useMemo(
    () => ({
      orderId: id,
      invoicesId: invoicesResult?.id,
      base: invoicesResult?.base,
      taxes: invoicesResult?.taxes,
      total: invoicesResult?.total + invoicesResult?.tips,
      discount: invoicesResult?.discount,
      tips: invoicesResult?.tips,
    }),
    [invoicesResult, id]
  );

  return {
    invalidateByCheckout,
    invoices,
    invoicesWhitOutFormat,
    billingInfo,
    generateBody,
    dataOrder,
    invoicesResult,
    reload,
  };
};
